import { apiGet } from "./client";

export interface AuditCheck {
  is_valid: boolean;
  name: string;
  [key: string]: unknown;
}

export interface AuditGroup {
  name: string;
  checks: AuditCheck[];
  subgroups: AuditGroup[];
}

export function getAuditDatas(scenarioId: number): Promise<AuditGroup[]> {
  return apiGet<AuditGroup[]>(`/audit/${scenarioId}`);
}

export function getSensitivityAuditDatas(
  sensitivityId: number,
): Promise<AuditGroup[]> {
  return apiGet<AuditGroup[]>(`/audit/sensitivity/${sensitivityId}`);
}
